/** A plain-language line for each event kind (the raw kind stays on screen above it). */
export const EVENT_TEXT: Record<string, string> = {
  backup_stale: "The last database backup is older than expected.",
  belt_mismatch: "Belt-scale tonnes disagree with the measured volume change.",
  change_unexplained: "Surface change that matches no recorded stacking or reclaiming.",
  density_clamped: "The density estimate hit its allowed limit and was clamped.",
  disk_critical: "Disk space is critically low.",
  disk_refuse_arm: "Recording refused: not enough disk space for a sweep.",
  disk_warn: "Disk space is running low.",
  failed_capture: "A sweep could not be recorded.",
  failed_filing: "A recorded sweep could not be filed for processing.",
  feed_state_unknown: "The stacker's feed state is not known.",
  floor_drift_suspected: "The pad floor appears to have moved since it was surveyed.",
  frames_dropped: "Lidar frames were lost during the sweep.",
  frames_unstamped: "Lidar frames arrived without a usable timestamp.",
  heartbeat_stale: "A service has stopped reporting in.",
  ingest_degraded: "Recording continues with reduced quality.",
  pile_cleared: "A pile has been reclaimed completely.",
  pile_merged: "Two piles have grown into one.",
  pile_new: "A new pile was detected.",
  pile_split: "A pile was split into two.",
  pose_invalid_columns: "Some boom position samples were unusable.",
  position_down: "The boom position feed is down.",
  position_source_lost: "The boom position feed was lost during a sweep.",
  ptp_unlocked: "The lidar clock is not locked to the time source.",
  retention_applied: "Old raw data was removed under the retention policy.",
  run_failed: "Processing of a sweep failed.",
  run_retries_exhausted: "Processing of a sweep failed after every retry.",
  self_mask_reset: "The mask of the stacker's own structure was rebuilt.",
  sensor_config_reapplied: "The lidar's configuration was set again.",
  sensor_metadata_changed: "The lidar reports different metadata (firmware or unit change).",
  sensor_mode_mismatch: "The lidar is not in the expected scan mode.",
  sensor_offline: "The lidar is not reachable.",
  skipped_disk_full: "A sweep was skipped: the disk is full.",
  skipped_metadata_changed: "A sweep was skipped: the lidar metadata changed.",
  skipped_sensor_config: "A sweep was skipped: the lidar configuration is wrong.",
  spool_cleaned: "Temporary recording files were cleaned up.",
  sweep_discarded: "A recorded sweep was discarded.",
  sweep_due: "A sweep is due.",
  sweep_overdue: "No sweep has been recorded within the expected interval.",
  sweep_recorded: "A sweep was recorded.",
  sweep_requested: "An operator requested a sweep.",
  sweep_started: "A sweep started.",
  timing_degraded: "Lidar and boom timing alignment is degraded.",
  timing_drift: "The lidar and boom clocks are drifting apart.",
  timing_unverified: "Lidar and boom timing could not be verified.",
  unexplained_blob: "An unexpected object was seen on the pad.",
};
